// external imports
import React, { useContext, useState, useEffect } from 'react';
import { Tooltip } from 'react-tooltip';
import Skeleton from 'react-loading-skeleton';
import Select from 'react-select';
import { Row, Col } from 'reactstrap';

// local imports
import exportConfig from '../../config';
import formatDate from '../../helpers/formatDate';

// custom hooks & context
import { pipelineContext } from '../../contexts/pipelineContext';
import { endpointContext } from '../../contexts/endpointContext';

const QCFormReQC = ({
	handleSubmit,
	formValue,
	setFormValue,
	formValid,
	setFormValid,
	error,
	setCapturesUrl,
	user,
	fetchSites,
	loading,
	props
}) => {
	//	console.log(fetchSites);

	const pipelineContextQCFormReQC = useContext(pipelineContext);
	const endpointContextQCFromReQC = useContext(endpointContext);
	const [siteOptions, setSiteOptions] = useState([]);
	const [selectedOptions, setSelectedOptions] = useState([]);

	console.log(endpointContextQCFromReQC)

	// useEffect(() => {
	// 	console.log("here 3")
	// 	if (pipelineContextQCFormReQC.comm === 'smelters') {
	// 		setFormValue({ ...formValue, formCommodities: [3] });
	// 	} else {
	// 		setFormValue({ ...formValue, formCommodities: [4] });
	// 	}
	// }, [pipelineContextQCFormReQC.comm]);

	// useEffect(() => {
	// 	console.log("here 3, formValue changed", formValue);
	//   }, [formValue]);

	useEffect(() => {
		//console.log("here 1")

		if (fetchSites?.data) {
			var options;
			options = fetchSites.data.data
				.filter((site) => site.commodity_id === formValue.formCommodities[0])
				.map(({ id, name }) => ({
					value: id,
					label: `${id} - ${name}`
				}))
				.sort((a, b) => a.label.localeCompare(b.label));

			setSiteOptions(options);
		}
	}, [formValue.formCommodities, fetchSites.loading]);

	useEffect(() => {
		//console.log("here 2")
		setFormValue({
			...formValue,
			formSiteId: ''
		});
	}, [formValue.formCommodities]);

	useEffect(() => {
		let firstName = props.authProps.userAttributes.givenName.toLowerCase();
		let lastName = props.authProps.userAttributes.familyName.toLowerCase();

		validateForm();

		// 08/10/24 LC - this should always be assign_captures, but the stockpiles EP for this is not
		// ready so we have to use the captures EP

		// qcStates=1 because Re-QC
		if (pipelineContextQCFormReQC.comm === 'smelters') {
			if (formValue.fullHistory) {
				setCapturesUrl(
					`assign_captures?startDate=2016-01-01&endDate=${formValue.formEndDate}&siteIds=${formValue.formSiteId}&qcStates=1&qcUser=${firstName}.${lastName}&expirationTime=30`
				);
			} else {
				setCapturesUrl(
					`assign_captures?startDate=${formValue.formStartDate}&endDate=${formValue.formEndDate}&siteIds=${formValue.formSiteId}&qcStates=1&qcUser=${firstName}.${lastName}&expirationTime=30`
				);
			}
		} else {
			if (formValue.fullHistory) {
				setCapturesUrl(
					`captures?startDate=2016-01-01&endDate=${formValue.formEndDate}&siteIds=${formValue.formSiteId}&qc=0&qcUser=${firstName}.${lastName}`
				);
			} else {
				setCapturesUrl(
					`captures?startDate=${formValue.formStartDate}&endDate=${formValue.formEndDate}&siteIds=${formValue.formSiteId}&qc=&qcUser=${firstName}.${lastName}`
				);
			}
		}
	}, [formValue]);

	const validateForm = () => {
		if (
			formValue.fullHistory &&
			formValue.formEndDate !== '' &&
			typeof formValue.formSiteId === 'number' &&
			formValue.formEndDate > formValue.formStartDate
		) {
			setFormValid(true);
		} else if (
			formValue.formEndDate !== '' &&
			formValue.formStartDate !== '' &&
			typeof formValue.formSiteId === 'number' &&
			formValue.formEndDate > formValue.formStartDate
		) {
			setFormValid(true);
		} else {
			setFormValid(false);
		}
	};

	const handleBackButton = (e) => {
		//console.log("handle back button")
		e.preventDefault();
		// setFormValue({
		// 	formSiteId: '',
		// 	formStartDate: '',
		// 	formEndDate: new Date().toISOString().substring(0, 10),
		// 	formAutoQC: true,
		// 	formEndDateNow: '',
		// 	fullHistory: true,
		// 	formSensors: ['sentinel-2-l1c', 'landsat-8-l1tp'],
		// 	formCommodities: [3],
		// 	formProdStates: [0, 1],
		// 	formLookback: 1,
		// 	manuallySelectSites: true
		// });

		pipelineContextQCFormReQC.setProgressBar({
			width: 2 * (100 / 7),
			title: 'QC Type'
		});
		pipelineContextQCFormReQC.setQCType(undefined);
	};

	const handleChange = (selectedValues) => {
		setSelectedOptions(selectedValues);
		setFormValue({ ...formValue, formSiteId: selectedValues.value });
	};

	const reloadSites = () => {
		fetchSites.makeRequest(
			`/${pipelineContextQCFormReQC.comm}/sites?hasCaptures=true`,
			'GET',
			null,
			'',
			1000
		);
	};

	return (
		<>
			<hr></hr>
			<form onSubmit={handleSubmit} className="px-3 mx-3">
				<div className="row">
					<div className="col d-flex justify-content-start align-items-center">
						<button
							className="btn interactButtonSecondary backButton"
							onClick={handleBackButton}
							style={{ width: '200px' }}
						>
							<i className="fa-solid fa-left-long pe-3"></i>
							Change QC type
						</button>
						<h1 className="ms-5 mt-2">QC</h1>
					</div>
					<div className="col"></div>
					<div className="col d-flex justify-content-end  align-items-center">
						{formValid && !loading ? (
							<>
								<button
									type="submit"
									className="btn interactButton mt-2 mx-0"
									style={{ maxHeight: '40px', width: '200px' }}
									data-tooltip-id="view-captures-TT"
								>
									View captures <i className="fa-solid fa-right-long ps-2"></i>
								</button>
							</>
						) : (
							<button
								disabled
								className="btn btn-secondary mt-2 mx-0"
								style={{ maxHeight: '40px', width: '200px' }}
								data-tooltip-id="view-captures-TT"
							>
								View captures <i className="fa-solid fa-right-long ps-2"></i>
							</button>
						)}
					</div>
				</div>

				<Tooltip id="view-captures-TT" place="bottom" effect="solid">
					Fetch captures from database and view list before QCing
				</Tooltip>

				<h4 className="py-3">
					Fill in the captures criteria for{' '}
					<span className="fw-bold">re-QC</span>
				</h4>

				<div className="row">
					<div className="col-12 col-xl-6 py-3 py-md-3 px-2 pe-lg-5">
						<div className="form-group" style={{ width: '90%' }}>
							<h5 className="card-title">Site</h5>
							<p className="fst-italic">Select one site</p> <br></br>
							<div className="form-group">
								<div className="d-flex flex-row flex-wrap align-items-center mb-3">
									{endpointContextQCFromReQC.dbData.allCommodities
										.filter(
											(comm) =>
												`${comm.siteTypeStr}s` ===
												pipelineContextQCFormReQC.comm
										)
										.map((comm, idx) => (
											<>
												<input
													id={`id${comm.id}`}
													type="radio"
													name="historic-form-site-comms-filter"
													value={comm.id}
													className="form-check-input"
													checked={formValue.formCommodities.includes(comm.id)}
													onClick={() =>
														setFormValue({
															...formValue,
															formCommodities: [comm.id]
														})
													}
												/>

												<label
													htmlFor={`id${comm.id}`}
													className={`form-label ms-1 me-4 my-0 ${
														formValue.formCommodities.includes(comm.id)
															? 'fw-bold'
															: ''
													}`}
												>
													{comm.name}
												</label>
											</>
										))}
								</div>
							</div>
							{fetchSites.loading ? (
								// <Select
								// 	options={siteOptions}
								// 	value={
								// 		siteOptions.filter(
								// 			(option) => option.value === formValue.formSiteId
								// 		)[0]
								// 	}
								// 	onChange={handleChange}
								// 	isSearchable
								// 	placeholder="Search by site name or id"
								// 	isDisabled={true}
								// />
								<Skeleton height={35} />
							) : (
								<>
									{formValue.formSiteId ? (
										<Select
											options={siteOptions}
											value={
												siteOptions.filter(
													(option) => option.value === formValue.formSiteId
												)[0]
											}
											onChange={handleChange}
											isSearchable
											placeholder="Search by site name or id"
											disabled={!endpointContextQCFromReQC.dbData.allCommodities}
										/>
									) : (
										<Select
											options={siteOptions}
											value={''}
											onChange={handleChange}
											isSearchable
											placeholder="Search by site name or id"
										/>
									)}
								</>
							)}
							{fetchSites.error && (
								<h6 className=" mt-2">
									<i
										id="sentinel-hub-icon"
										onClick={() => reloadSites()}
										className="me-2 fa-solid fa-arrows-rotate"
										data-tooltip-id="reload-sites-historic-form"
									></i>{' '}
									Could not fetch sites at this time
								</h6>
							)}
							{fetchSites.loading && <h6 className="mt-2">Loading sites ..</h6>}
							<Tooltip
								id="reload-sites-historic-form"
								place="bottom"
								effect="solid"
							>
								Reload sites
							</Tooltip>
						</div>
					</div>
					<div className="col-1"></div>
					<div className="col-12 col-lg-6 col-xl-5 py-3 py-md-3 px-2 pe-lg-5">
						<div className="form-group">
							<h5 className="card-title">Interval</h5>
							<p className="fst-italic">Set interval period</p> <br></br>
							<div className="row">
								<div className="d-flex flex-column">
									<div className="d-flex flex-row">
										<input
											id="full-history-true"
											type="radio"
											name="QCFormHistoricFullHistory"
											value={true}
											className="form-check-input"
											defaultChecked={formValue.fullHistory === true}
											onClick={(e) =>
												setFormValue({
													...formValue,
													fullHistory: true,
													formStartDate: ''
												})
											}
										></input>
										<label for="full-history-true" className="form-label ms-2">
											Full capture history
										</label>
									</div>
									<div className="d-flex flex-row">
										<input
											id="full-history-false"
											type="radio"
											name="QCFormHistoricFullHistory"
											value={false}
											defaultChecked={formValue.fullHistory === false}
											className="form-check-input"
											onClick={(e) =>
												setFormValue({
													...formValue,
													fullHistory: false
												})
											}
										></input>
										<label for="full-history-false" className="form-label ms-2">
											Choose specific dates
										</label>
									</div>
								</div>
							</div>
							<div className="row mt-5">
								<h6>Selecting captures between</h6>

								<div className="col-5 d-flex justify-content-evenly">
									{formValue.formStartDate ? (
										<span className="fw-bold">
											{formatDate(formValue.formStartDate)}
										</span>
									) : (
										<span className="fw-bold">earliest capture date</span>
									)}

									<p> at </p>
									<span className="fw-bold ms-2"> 00:00</span>
								</div>
								<div className="col-2 d-flex justify-content-center">and </div>
								<div className="col-5 d-flex justify-content-evenly">
									<span className="fw-bold">
										{formatDate(formValue.formEndDate)}
									</span>{' '}
									at{' '}
									{formValue.fullHistory ? (
										<span className="fw-bold">
											{new Date().toLocaleTimeString().slice(0, 4)}
										</span>
									) : (
										<span className="fw-bold">00:00</span>
									)}
								</div>
							</div>
							{formValue.fullHistory === false && (
								<Row className="py-2">
									<Col className="col-6 pe-1">
										<label for="start_date">Start date</label> <br></br>
										{formValue.fullHistory ? (
											<input
												className="form-control text-sm"
												id="start_date"
												name="formStartDate"
												title="start date of interval"
												max={new Date().toISOString().split('T')[0]}
												type="date"
												value=""
												disabled
											></input>
										) : (
											<input
												className="form-control text-sm"
												id="start_date"
												name="formStartDate"
												title="start date of interval"
												type="date"
												max={new Date().toISOString().split('T')[0]}
												value={formValue.formStartDate}
												onChange={(e) =>
													setFormValue({
														...formValue,
														formStartDate: e.target.value
													})
												}
											></input>
										)}
										<br></br>
									</Col>
									<Col className="col-6 ps-1">
										<label for="end_date">End date</label> <br></br>
										<input
											className="form-control text-sm"
											id="end_date"
											name="formEndDate"
											title="End date of interval"
											type="date"
											max={new Date().toISOString().split('T')[0]}
											value={formValue.formEndDate}
											onChange={(e) =>
												setFormValue({
													...formValue,
													formEndDate: e.target.value
												})
											}
										></input>
										<br></br>
									</Col>

									{formValue.formStartDate > formValue.formEndDate && (
										<p id="sensor-err" className="text-warning pt-3">
											<i class="fa-solid fa-triangle-exclamation"></i> The start
											date is after the end date
										</p>
									)}
								</Row>
							)}
						</div>
					</div>{' '}
				</div>
			</form>
		</>
	);
};

export default QCFormReQC;
